import { GerenciamentoPermissoesModels } from '../models/gerenciamento-permissoes.model';
import * as GereciamentoPermissoesActions from '../actions/gerenciamento-permissoes.action';

export const gerenciamentoPermissoes: GerenciamentoPermissoesModels = new GerenciamentoPermissoesModels();

export function gereciamentoPermissoesReducer(state: GerenciamentoPermissoesModels = gerenciamentoPermissoes,
     action: GereciamentoPermissoesActions.Actions) {
    switch (action.type) {
        case GereciamentoPermissoesActions.ADD_GERENCIAMENTO_PERMISSOES:
            {
                state.liberarAcesso = action.payload.liberarAcesso;
                // console.log('ADD_GERENCIAMENTO_PERMISSOES ', state);
                return state;
            };

        case GereciamentoPermissoesActions.CLEAR_GERENCIAMENTO_PERMISSOES:
            {
                state = new GerenciamentoPermissoesModels();
                return state;
            }

        default:
            return state;
        }

}





// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/reducers/gerenciamento-permissoes.reducer.ts